<template>
  <div class="main">
    <div class="header">
      <div class="logo">
        <img :src="$headLogo" alt="$headLogo" :onerror="`this.src='${$defaultHeadLogo}'`" />
      </div>
      <div class="right">
        <span v-if="!hideHelpBtn" @click="manualHelpBtn">帮助手册 </span>
        <span v-if="!hideDownloadBtn" @click="plugBtn">插件下载</span>
        <a href="http://www.bimex.com.cn/index.html" target="_blank" style="color: #000">官网首页</a>
        <a href="http://www.bimex.com.cn/aboutUs/index.html" target="_blank" style="color: #000">关于我们</a>
      </div>
    </div>
    <div class="content">
      <div class="contentLeft">
        <transition-group name="flip-list" tag="ul">
          <li v-for="curImg in currImgs" :key="curImg" class="list-item">
            <img :src="curImg" />
          </li>
        </transition-group>
      </div>
      <div class="loginStyleForm">
        <img src="./img/erweima.png" alt="二维码" class="erweima" />
        <span class="title"> 账号登录 </span>
        <el-form ref="loginForm" :model="loginForm" :rules="rules" label-position="left" label-width="0px" class="demo-ruleForm loginPage">
          <el-form-item prop="username">
            <el-input v-model="loginForm.username" type="text" auto-complete="off" placeholder="请输入账号" style="width: 358px" @keydown.native="keydown($event)"></el-input>
          </el-form-item>
          <el-form-item prop="password" style="margin-top: 58px">
            <el-input
              v-model="loginForm.password"
              :type="passwordType"
              autocomplete="off"
              placeholder="请输入密码"
              style="width: 358px"
              class="passwordStyle"
              @keydown.native="keydown($event)"
              @input="changeInputValue1(loginForm.password)"
            >
              <p v-if="passwordType == 'text' && loginForm.password" slot="suffix" class="bukejin" @click="showPwd"></p>
              <p v-if="passwordType == 'password' && loginForm.password" slot="suffix" class="nobukejin" @click="showPwd"></p>
            </el-input>
          </el-form-item>
          <el-form-item style="margin-top: 58px">
            <el-button class="handleLoginStyle" :loading="logining" type="primary" @click="handleLogin('loginForm')"> 登录 </el-button>
          </el-form-item>
          <div class="loginFormFoot">
            <p style="margin-top: 15px" @click="goregister">
              <span style="color: #333">暂无账号?</span>
              <span>立即注册&gt;</span>
            </p>
            <p style="margin-top: 12px" @click="gppassword">
              <span>忘记密码?</span>
            </p>
          </div>
        </el-form>
      </div>
    </div>
    <div class="footer">
      <a href="https://beian.miit.gov.cn/" target="_blank">{{ systemFiling.filingNo }}</a>
      <a :href="systemFiling.linkUrl" target="_blank">{{ systemFiling.filingEnterprise }}</a>
      |
      <img src="./img/wangjing.png" alt="网警" />
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=" target="_blank"></a>
      <div class="footerright">
        <span>法律声明</span>
        <span class="nbsp">|</span>
        <span>隐私政策声明</span>
        <span class="nbsp">|</span>
        <span @click="versionInfo">版本信息</span>
      </div>
    </div>
    <!-- 插件端下载 -->
    <app-download v-if="appDownloadShow" ref="appDownload" :plug-form="plugForm" :app-form="appForm" />
    <!-- 版本信息 -->
    <el-dialog v-dialogDrag :visible.sync="versionInfoDialog" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="cancel" title="版本信息" width="400px">
      <el-table :data="versionInfoList" :show-header="false" max-height="300px">
        <el-table-column label="名称" prop="name" align="left" />
        <el-table-column label="操作" prop="verson" align="right" />
      </el-table>
    </el-dialog>
    <slide-verify :show="showVerify" @success="onVerifySuccess" @close="onVerifyClose"></slide-verify>
  </div>
</template>
<script>
import loginService from "@/CommonDP/service/login-service";
import { mapState } from "vuex";
import enterpriseService from "@/CommonDP/service/enterprise-service";
import { storage } from "@/CommonDP/utils";
import JSEncrypt from "jsencrypt";
import globalParams from "@/CommonDP/utils/globalParams";
import appDownload from "@/CommonDP/components/appDownload/index.vue";
import slideVerify from "vue-puzzle-vcode";
export default {
  name: "Login",
  components: { appDownload, slideVerify },
  data() {
    return {
      imageLogo: "",
      loginForm: {
        username: "",
        password: ""
      },
      logining: false,
      rules: {
        username: [
          {
            required: true,
            message: "请输入账号",
            trigger: "blur"
          }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      passwordType: "password",
      erpriseList: [],
      imgs: [require("./img/pic2.png"), require("./img/pic3.png")],
      currImgs: [require("./img/pic2.png")],
      index: 0,
      plugForm: {
        createTime: "",
        filePath: ""
      },
      appForm: {
        createTime: "",
        filePath: ""
      },
      hideHelpBtn: false,
      hideDownloadBtn: false,
      appDownloadShow: false,
      versionInfoDialog: false,
      versionInfoList: [],
      systemInfo: [],
      failedCount: 0,
      showVerify: false
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      systemFiling: (state) => state.enterprise.systemFiling
    })
  },
  mounted() {
    this.$store.dispatch("GetSystemFiling");
    this.hideHelpBtn = globalParams.get("hideHelpBtn");
    this.hideDownloadBtn = globalParams.get("hideDownloadBtn");
    this.startChange();
    this.getSystemFiling();
  },
  methods: {
    async getSystemFiling() {
      const res = await loginService.getPublicSystemInfo();
      this.systemInfo = Object.entries(res.data).map((item) => {
        return {
          name: item[0],
          verson: item[1] ? item[1] : "一"
        };
      });
    },
    cancel() {
      this.versionInfoDialog = false;
      this.versionInfoList = [];
    },
    versionInfo() {
      this.versionInfoDialog = true;
      const webV = [
        {
          name: "web端",
          verson: this.$Config.version
        }
      ];
      this.versionInfoList = webV.concat(this.systemInfo);
    },
    // 帮助手册提示
    manualHelpBtn() {
      this.$message.warning("请登录后再进行帮助手册的查看与下载操作");
    },
    async plugBtn() {
      const res = await enterpriseService.getPlugList();
      if (res.data && res.data.length > 0) {
        res.data.forEach((item) => {
          if (item.fileType === 15 || item.fileType === 17) {
            const a = item.createTime.split(" ")[0];
            this.plugForm.createTime = a.replace(/-/g, "/");
            this.plugForm.filePath = item.filePath;
          }
          if (item.fileType === 10) {
            const a = item.createTime.split(" ")[0];
            this.appForm.createTime = a.replace(/-/g, "/");
            this.appForm.filePath = item.filePath;
          }
        });
        this.appDownloadShow = true;
        this.$nextTick(() => {
          this.$refs.appDownload.showDialog();
        });
      }
      this.appDownloadShow = true;
      this.$nextTick(() => {
        this.$refs.appDownload.showDialog();
      });
    },
    startChange() {
      var _this = this;
      setInterval(() => {
        if (_this.index < _this.imgs.length - 1) {
          _this.index++;
        } else {
          _this.index = 0;
        }
        _this.currImgs.splice(0, 1, _this.imgs[_this.index]);
      }, 5000);
    },
    changeInputValue1() {
      if (!this.loginForm.password) {
        this.passwordType = "text";
      } else {
        this.passwordType = "password";
      }
    },
    keydown(event) {
      if (event.keyCode === 32) {
        event.returnValue = false;
      }
    },
    encPwd() {
      if (!this.loginForm.password) {
        return;
      }
      if (this.loginForm.password.startsWith("_XXX_")) {
        return;
      }
      const encrypt = new JSEncrypt();
      encrypt.setPublicKey(globalParams.get("login.pwd.encRsaPublicKey", ""));
      const encrypted = encrypt.encrypt(this.loginForm.password);
      return globalParams.get("login.pwd.encryptedPwdPrefix", "") + encrypted;
    },

    async handleLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.failedCount >= 1) {
            this.showVerify = true;
          } else {
            this.login();
          }
        } else {
          return false;
        }
      });
    },

    login() {
      this.logining = true;
      const data = new FormData();
      data.append("username", this.loginForm.username);
      data.append("password", this.encPwd());
      loginService.loginByUsername(data).then((res) => {
        this.$store.dispatch("clearStorage");
        this.$store.dispatch("setUserInfo", res.data);
        this.logining = false;
        // 被别人邀请但是没有登录
        if (this.$route.query.code) {
          var code = this.$route.query.code;
          this.$router.replace({
            path: "/joinEnterprise",
            query: { code: code }
          });
        } else {
          // 直接登录
          enterpriseService.usergetEnterpriseList().then((res) => {
            if (res.result === "0") {
              // 登录成功触发在线用户统计接口
              if (this.prjInfo.prjId) {
                const params = {
                  prjId: this.prjInfo.prjId,
                  clientType: "WEB端"
                };
                loginService
                  .onlineUserSave(params)
                  .then((result) => {
                    console.warn(params, result, "login.vue在线人数统计");
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }

              this.erpriseList = res.data;
              var ll = this.erpriseList.length;
              if (ll) {
                // 有一个企业
                if (ll === 1) {
                  // 如果只有一个企业 不用判断用哪一个 直接用这一个
                  // status 企业的状态 0 审核中 1 通过 2 驳回 3解散 4禁用
                  // 先判断企业的状态 如果企业被驳回了 跳到驳回重新申请页面
                  // 如果企业通过了(不管是我创建的企业 还是我加入的企业joinStatus都是1)判断企业有没有启用/禁用等
                  // 如果企业审批中 提示我创建的企业在审核中
                  if (this.erpriseList[0].status === 0) {
                    // 审核中 创建的
                    // 没有设置企业
                    const { href } = this.$router.resolve({
                      path: "/noenterprise",
                      query: {
                        showtype: 1,
                        name: this.erpriseList[0].enterpriseName
                      }
                    });
                    window.open(href, "_blank");
                  } else if (this.erpriseList[0].status === 1) {
                    // 通过 企业通过的情况下 企业创建人 一定是加入的状态   后来加入的人 才会走到审核中状态里
                    // 加入的人 没有驳回的状态 发信息通知 企业列表里 没有加入的人 是驳回的状态
                    if (this.erpriseList[0].joinStatus === 1) {
                      // 启用
                      if (this.erpriseList[0].isEnabled === 1) {
                        enterpriseService
                          .userselectEnterprise(this.erpriseList[0].enterpriseId)
                          .then((res) => {
                            if (res.result === "0") {
                              this.$store.dispatch("setUnauthorized", 1);
                              this.$store.dispatch("setEnterpriseId", this.erpriseList[0].enterpriseId);
                              this.$store.dispatch("setIsTrial", this.erpriseList[0].isTrial);
                              this.$router.push({ name: "mainMg" }); // 记录id
                            }
                          })
                          .catch(() => {});
                      } else {
                        // 禁用(我被企业禁用)
                        this.$store.dispatch("setUnauthorized", 110); // 110 第一个1代表status 第二个1代表joinStatus 第三0代表isEnabled
                        const { href } = this.$router.resolve({
                          path: "/noenterprise",
                          query: {
                            showtype: 2,
                            name: this.erpriseList[0].enterpriseName
                          }
                        });
                        window.open(href, "_blank");
                      }
                    } else if (this.erpriseList[0].joinStatus === 0) {
                      // 审核中 加入的 一定是加入的(这个逻辑后续不要了 暂时放在这里)
                      const { href } = this.$router.resolve({
                        path: "/noenterprise",
                        query: {
                          showtype: 3,
                          name: this.erpriseList[0].enterpriseName
                        }
                      });
                      window.open(href, "_blank");
                    }
                  } else if (this.erpriseList[0].status === 2) {
                    // 驳回
                    this.$router.replace({
                      path: "/creationcomplete",
                      query: { id: this.erpriseList[0].enterpriseId }
                    });
                  } else if (this.erpriseList[0].status === 4) {
                    // 禁用(企业被禁用)
                    const { href } = this.$router.resolve({
                      path: "/noenterprise",
                      query: {
                        showtype: 4,
                        name: this.erpriseList[0].enterpriseName
                      }
                    });
                    window.open(href, "_blank");
                  }
                } else {
                  // 选择企业
                  const erpriseLists = this.erpriseList.filter((item) => item.isSelect === 1);
                  // status 企业的状态 0 审核中 1 通过 2 驳回 3解散 4禁用
                  // console.log(erpriseLists[0],'officersIds');
                  // 有最后一个登录的企业 判断最后一个企业是不是能用的 最后一个登录的企业 一定是审核通过的 只有可能是审核通过以后被解散的 企业被禁用的 或者这个人被禁用了
                  // 被解散的企业不会再列表里
                  if (erpriseLists.length) {
                    if (erpriseLists[0].status === 4) {
                      this.$store.dispatch("setUnauthorized", 4);
                      const { href } = this.$router.resolve({
                        path: "/noenterprise",
                        query: {
                          showtype: 4,
                          name: erpriseLists[0].enterpriseName
                        }
                      });
                      window.open(href, "_blank");
                    } else if (erpriseLists[0].status === 1 && erpriseLists[0].isEnabled === 0) {
                      // 禁用(我被企业禁用)
                      this.$store.dispatch("setUnauthorized", 110);
                      const { href } = this.$router.resolve({
                        path: "/noenterprise",
                        query: {
                          showtype: 2,
                          name: erpriseLists[0].enterpriseName
                        }
                      });
                      window.open(href, "_blank");
                    } else {
                      this.$store.dispatch("setUnauthorized", 1);
                      this.$store.dispatch("setEnterpriseId", erpriseLists[0].enterpriseId);
                      this.$store.dispatch("setIsTrial", erpriseLists[0].isTrial);
                      this.$router.push({ name: "mainMg" }); // 记录id
                    }
                  } else {
                    // 没有最后登录的企业
                    this.$router.push("/changeenterprise");
                  }
                }
              } else {
                // 没有企业 跳转 创建/加入企业
                this.$router.replace({
                  path: "/enterprisepage",
                  query: { pagetype: "0" }
                });
              }
            }
          });
        }
      })
        .catch(() => {
          this.logining = false;
          this.failedCount++;
        });
    },

    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "text";
      } else {
        this.passwordType = "password";
      }
    },
    goregister() {
      storage.set("stepsIndex", 0);
      if (this.$route.query.code) {
        var code = this.$route.query.code;
        this.$router.replace({ path: "/register", query: { code: code }});
      } else {
        this.$router.push({ name: "register" });
      }
    },
    gppassword() {
      storage.set("stepsIndex2", 0);
      if (this.$route.query.code) {
        var code = this.$route.query.code;
        this.$router.replace({ path: "/password", query: { code: code }});
      } else {
        this.$router.push({ name: "password" });
      }
    },
    onVerifySuccess() {
      this.showVerify = false;
      this.failedCount = 0;
      this.$success("验证成功");
      this.login();
    },
    onVerifyClose() {
      this.showVerify = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.main {
  width: 100%;
  height: 100%;
  min-height: 700px;
  min-width: 800px;
  overflow: auto;
  .header {
    width: 100%;
    height: 68px;
    padding: 0 25px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .right {
      display: flex;
      flex-direction: row;
      align-items: center;
      span,
      a {
        margin-right: 20px;
        cursor: pointer;
      }
    }
  }
  .content {
    width: 100%;
    height: calc(100% - 120px);
    background: url("./img/background.png") no-repeat;
    background-size: cover;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 25px;
    @media (max-width: 1440px) {
      .contentLeft {
        width: 560px;
        height: 535px;
        display: inline-block;
        margin-left: 10px;
        overflow: hidden;
        position: relative;
      }
    }
    @media (min-width: 1440px){
      .contentLeft {
        width: 700px;
        height: 535px;
        display: inline-block;
        margin-left: 150px;
        overflow: hidden;
        position: relative;
      }
    }
    .contentLeft {
      /deep/ .el-carousel__indicators--horizontal {
        display: none;
      }
      /deep/ .el-carousel__arrow--left {
        display: none;
      }
      /deep/ .el-carousel__arrow--right {
        display: none;
      }
      .flip-list-enter-active,
      .flip-list-leave-active {
        transition: all 3s;
      }
      .flip-list-enter,
      .flip-list-leave-active {
        opacity: 0;
      }
      li {
        position: absolute;
        top: 0;
        left: 0;
        height: 535px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        img{
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
    @media (max-width: 1440px) {
      .loginStyleForm{
        position: absolute;
        top: calc(50% - 250px);
        right: 10px;
        width: 420px;
        height: 500px;
        background: #ffffff;
        box-shadow: 0px 0px 4px rgba(55, 106, 227, 0.1);
        border-radius: 5px;
        display: flex;
        flex-direction: column;
      }
    }
    @media (min-width: 1440px){
      .loginStyleForm {
        position: absolute;
        top: calc(50% - 250px);
        right: 180px;
        width: 420px;
        height: 500px;
        background: #ffffff;
        box-shadow: 0px 0px 4px rgba(55, 106, 227, 0.1);
        border-radius: 5px;
        display: flex;
        flex-direction: column;
      }
    }
    .loginStyleForm {
      .erweima {
        position: absolute;
        top: 0;
        right: 0;
        user-select: none;
      }
      .title {
        width: 100%;
        height: 100px;
        text-align: center;
        user-select: none;
        font-size: 24px;
        line-height: 24px;
        padding-top: 60px;
      }
      .loginPage {
        width: 100%;
        padding-top: 67px;
        display: flex;
        flex-direction: column;
        align-items: center;
        /deep/ .el-form-item {
          margin-bottom: 0px;
          .el-input__inner {
            background: #e8f0fe;
            border-color: #fff;
            border-radius: 2px;
            color: #6681a0;
            height: 46px;
          }
          .el-input__inner:focus {
            border-color: var(--theme-color);
          }
          .el-button--primary {
            background: #72a6fe !important;
          }
          .el-button--primary:hover {
            background: var(--theme-color) !important;
          }
          .el-form-item__content {
            line-height: 0px;
          }
        }
        .passwordStyle {
          p {
            width: 20px;
            height: 16px;
            background-size: 100% 100%;
            background-position: center center;
            margin-top: 15px;
            margin-right: 15px;
          }
        }
        .bukejin {
          background: url("./img/openEye.png") no-repeat;
        }
        .nobukejin {
          background: url("./img/closeEye.png") no-repeat;
        }
        .handleLoginStyle {
          width: 358px !important;
          height: 46px !important;
          border-radius: 2px !important;
          border: none !important;
        }
      }
      label.el-checkbox.rememberme {
        margin: 8px 0px 26px 279px;
      }
      .loginFormFoot {
        width: 358px;
        height: 42px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        span {
          font-size: 14px;
          color: #1e6ef5;
          cursor: pointer;
        }
      }
    }
  }
  .footer {
    width: 100%;
    height: 52px;
    padding: 0 25px;
    display: flex;
    flex-direction: row;
    align-items: center;
    a,
    span {
      color: currentColor;
    }
    a {
      margin-right: 5px;
    }
    img {
      margin-left: 5px;
      margin-right: 5px;
      width: 15px;
      height: 15px;
      user-select: none;
    }
    .footerright {
      margin-left: auto;
      span {
        user-select: none;
      }
      .nbsp {
        margin-left: 20px;
        margin-right: 20px;
      }
    }
  }
}

</style>
